import { LiveProps } from 'src/pages/CommunityDetails/Posts/live';
import type { PermissionActions } from 'src/services/posts';

export type PathParams = {
  idCommunity: string;
  idPost: string;
};

export enum PostType {
  URL = 0,
  VIDEO = 1,
  AUDIO = 2,
  IMAGE = 3,
  TEXT = 4,
  DOCUMENT = 6,
  MEDIA = 7
}

export type PostProps = {
  id: number;
  authorName: string;
  authorImagePath: string;
  authorHasImage: boolean;
  authorMemberType: string;
  title: string;
  pubDate: number;
  isAuthor: boolean;
  postType: number;
  authorId: number;
  membershipInfo: MembershipInfoProps;
  ownerCollectionName?: string;
  isFixed?: boolean;
  link?: string;
  description?: string;
  descriptionEnriched?: string;
  richDescription?: string;
  canUserComment?: boolean;
  mostRecentCommentDate?: number;
  authorImageFinalUrl?: string;
  isCommentsEnabled?: boolean;
  mediaHeight?: number;
  mediaWidth?: number;
  commentsCount?: number;
  communityId?: number;
  content?: string;
  domainURL?: string;
  domainImage?: string;
  hasUnseenReactions?: boolean;
  reactions?: Reaction[];
  ownerCollectionId?: number;
  ownerCollectionPermissions?: OwnerCollectionsPermissions;
  scheduledPubDate?: string;
  scheduledPubTimeZoneId?: string;
  live?: LiveProps;
};

export type MembershipInfoProps = {
  membershipId: string;
  courseId?: number;
  lessonHash?: string;
  courseTag?: string;
};

export type Reaction = {
  reactionCode: string;
  count: number;
  reactedByUser: boolean;
};

export type OwnerCollectionsPermissions = {
  group: OwnerCollectionsPermissionsGroup;
  actions?: PermissionActions[];
};

export type OwnerCollectionsPermissionsGroup =
  | 'OWNER'
  | 'ADMIN'
  | 'MODERATOR'
  | 'FOLLOWER'
  | 'VIEWER';
